import { actionTypes } from './constants';
import { getApiActionCreator } from 'helpers/actionHelper';

export const getFFTAction = getApiActionCreator(actionTypes.GET_FFT_V2_ACTION);
export const get2DFFTAction = getApiActionCreator(actionTypes.GET_2D_FFT_V2_ACTION);
export const getFFTTimestampAction = getApiActionCreator(actionTypes.GET_FFT_V2_TIMESTAMP_LIST_ACTION);

export const getFFTV2Data = (isTimestampsAvailable) => ({
    type: actionTypes.GET_FFT_V2_REQUEST,
    isTimestampsAvailable
});

export const getFFTTimestampList = (startTime, endTime) => ({
    type: actionTypes.GET_FFT_V2_TIMESTAMP_LIST_REQUEST,
    startTime,
    endTime
});

export const getFFTDataByTimestamp = (fftTimestamps, setShowHistoricalDialog, isFor2d) => ({
    type: actionTypes.GET_FFT_V2_DATA_BY_TIMESTAMP_REQUEST,
    fftTimestamps,
    setShowHistoricalDialog,
    isFor2d
});

export const setSelectedDates = (from, to) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.SET_DATE_SELECTION, dateSelection: { from, to } });
    };
};

export const setSelectedTimestamps = (timestamps, selectedAsset, selectedOrganization) => ({
    type: actionTypes.SET_FFT_V2_SELECTED_TIMESTAMPS,
    timestamps,
    selectedAsset,
    selectedOrganization,
});

export const setSelected2DTimestamp = (timestamps, selectedAsset, selectedOrganization) => ({
    type: actionTypes.SET_2D_FFT_V2_SELECTED_TIMESTAMP,
    timestamps,
    selectedAsset,
    selectedOrganization,
});

export const setSelectedLegends = (selectedLegends) => ({
    type: actionTypes.SET_FFT_V2_SELECTED_LEGENDS,
    selectedLegends
});

export const setSelected2DLegends = (selectedLegends) => ({
    type: actionTypes.SET_2D_FFT_V2_SELECTED_LEGENDS,
    selectedLegends
});

export const setSelectedSpectrumRange = (spectrumRange) => ({
    type: actionTypes.SET_FFT_V2_SELECTED_SPECTRUM_RANGE,
    spectrumRange
});

export const setSelectedChartView = (chartView) => ({
    type: actionTypes.SET_FFT_V2_SELECTED_CHART_VIEW,
    chartView
});

export const setSelectedXAxisUnit = (xAxisUnit) => ({
    type: actionTypes.SET_FFT_V2_SELECTED_XAXIS_UNIT,
    xAxisUnit
});

export const setChartLoader = (loadingStatus) => ({
    type: actionTypes.SET_FFT_V2_CHART_LOADER,
    loadingStatus
});

export const setBearingFaultSwitch = (status) => ({
    type: actionTypes.SET_FFT_BEARING_FAULT_SWITCH,
    status,
    isToggle: !!status
});

export const setBearingFaultType = (bearingType) => ({
    type: actionTypes.SET_FFT_BEARING_FAULT_TYPE,
    bearingType
});

export const setBearingFaultFrequencies = (frequencies) => ({
    type: actionTypes.SET_FFT_BEARING_FAULT_FREQUENCIES,
    frequencies
});

export const setSpeedHarmonicsSwitch = (status) => ({
    type: actionTypes.SET_FFT_SPEED_HARMONICS_SWITCH,
    status,
    isToggle: !!status
});

export const setSelectedEchartView = (echartView) => ({
    type: actionTypes.SET_FFT_V2_ECHART_VIEW,
    echartView
});

export const setSelectedEchartLegend = (echartLegend) => ({
    type: actionTypes.SET_FFT_V2_ECHART_LEGEND,
    echartLegend
});

export const setEchartBandSettings = (bandSettings) => ({
    type: actionTypes.SET_FFT_V2_ECHART_BAND_SETTINGS,
    bandSettings
});

export const setEchartFrequencyRange = (frequencyRange) => ({
    type: actionTypes.SET_FFT_V2_ECHART_FREQUENCY_RANGE,
    frequencyRange
});
